import { render } from "./WorkWithUsView.vue?vue&type=template&id=5bb14004&scoped=true"
import script from "./WorkWithUsView.vue?vue&type=script&lang=js"
export * from "./WorkWithUsView.vue?vue&type=script&lang=js"

import "./WorkWithUsView.vue?vue&type=style&index=0&id=5bb14004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb14004"]])

export default __exports__